// Survey sections data extracted from SurveySection component.
// Reordered so personal particulars is LAST (sectionNumber 37) and all situations renumbered starting at 1.

export const SURVEY_SECTIONS = [
  // Situation sections (each with 4 Likert questions)
  {
    sectionNumber: 1,
    title: '[Situation 1]',
    description:
      'You’re selected for a highly competitive role or program that reflects your growing reputation and future potential.',
    questions: [
      {
        id: 'q4',
        number: 4,
        type: 'likert',
        text: '[Response 1] You humbly thank everyone for their support.',
      },
      {
        id: 'q5',
        number: 5,
        type: 'likert',
        text: '[Response 2] You feel flooded with emotion and can’t think straight.',
      },
      {
        id: 'q6',
        number: 6,
        type: 'likert',
        text: '[Response 3] You push yourself—and others—harder than ever, getting irritated when people slow you down.',
      },
      {
        id: 'q7',
        number: 7,
        type: 'likert',
        text: '[Response 4] You post it on social media in a way that makes sure everyone sees how excited you are.',
      },
    ],
  },
  {
    sectionNumber: 2,
    title: '[Situation 2]',
    description:
      'You come into an unexpected financial gain, such as a large bonus, successful investment, or inheritance.',
    questions: [
      {
        id: 'q8',
        number: 8,
        type: 'likert',
        text: '[Response 1] You use the money in a way that feels meaningful to you, even if others find it odd.',
      },
      {
        id: 'q9',
        number: 9,
        type: 'likert',
        text: '[Response 2] You make a careful plan to allocate the financial gain to different uses.',
      },
      {
        id: 'q10',
        number: 10,
        type: 'likert',
        text: '[Response 3] You can’t shake the feeling that someone’s setting you up.',
      },
      {
        id: 'q11',
        number: 11,
        type: 'likert',
        text: '[Response 4] You hand it over to someone else—you don’t feel confident managing it on your own.',
      },
    ],
  },
  {
    sectionNumber: 3,
    title: '[Situation 3]',
    description:
      'You’re honored with a milestone award or benefit that celebrates the impact of your sustained effort over time.',
    questions: [
      {
        id: 'q12',
        number: 12,
        type: 'likert',
        text: '[Response 1] You’re so overwhelmed you feel it in your body—for example, your chest tightens, your hands shake.',
      },
      {
        id: 'q13',
        number: 13,
        type: 'likert',
        text: '[Response 2] You enjoy the praise and quietly leave out the part someone else helped you a lot.',
      },
      {
        id: 'q14',
        number: 14,
        type: 'likert',
        text: '[Response 3] You wonder why it took so long and feel like this should’ve happened years ago.',
      },
      {
        id: 'q15',
        number: 15,
        type: 'likert',
        text: '[Response 4] You feel proud but quickly wonder what expectations will come next.',
      },
    ],
  },
  {
    sectionNumber: 4,
    title: '[Situation 4]',
    description:
      'You meet someone who truly understands and appreciates you, and over time, the bond grows into a deep emotional connection.',
    questions: [
      {
        id: 'q16',
        number: 16,
        type: 'likert',
        text: '[Response 1] You feel drawn to them but are too shy to reach out.',
      },
      {
        id: 'q17',
        number: 17,
        type: 'likert',
        text: '[Response 2] You want to talk to them all the time—you can’t help it.',
      },
      {
        id: 'q18',
        number: 18,
        type: 'likert',
        text: '[Response 3] You let it grow naturally without trying to control anything.',
      },
      {
        id: 'q19',
        number: 19,
        type: 'likert',
        text: '[Response 4] You get anxious anytime they don’t respond right away.',
      },
    ],
  },
  {
    sectionNumber: 5,
    title: '[Situation 5]',
    description:
      'You complete a personal undertaking--like completing a major artistic project, home/apartment remodel, or engine repair--that you\'ve poured your heart into.',
    questions: [
      {
        id: 'q20',
        number: 20,
        type: 'likert',
        text: '[Response 1] You feel more sure of yourself and what you can do.',
      },
      {
        id: 'q21',
        number: 21,
        type: 'likert',
        text: '[Response 2] You talk about it in a way that makes others believe you achieved more than you actually did.',
      },
      {
        id: 'q22',
        number: 22,
        type: 'likert',
        text: '[Response 3] You worry it was just luck and probably won’t last.',
      },
      {
        id: 'q23',
        number: 23,
        type: 'likert',
        text: '[Response 4] You look ahead to the next challenge, hoping it inspires others too.',
      },
    ],
  },
  {
    sectionNumber: 6,
    title: '[Situation 6]',
    description:
      'Someone you respect offers a huge compliment about you in front of others.',
    questions: [
      {
        id: 'q24',
        number: 24,
        type: 'likert',
        text: '[Response 1] You laugh nervously and say, “I don’t know if I really deserve that.”',
      },
      {
        id: 'q25',
        number: 25,
        type: 'likert',
        text: '[Response 2] You start explaining what could’ve been done better.',
      },
      {
        id: 'q26',
        number: 26,
        type: 'likert',
        text: '[Response 3] You nod and agree—it sounds about right to you.',
      },
      {
        id: 'q27',
        number: 27,
        type: 'likert',
        text: '[Response 4] You just say “thanks” without showing much feeling.',
      },
    ],
  },
  {
    sectionNumber: 7,
    title: '[Situation 7]',
    description:
      'After you receive some bad news, a friend or coworker offers you unexpected support.',
    questions: [
      {
        id: 'q28',
        number: 28,
        type: 'likert',
        text: '[Response 1] You feel grateful and openly accept their kindness.',
      },
      {
        id: 'q29',
        number: 29,
        type: 'likert',
        text: '[Response 2] You wonder if they have an agenda.',
      },
      {
        id: 'q30',
        number: 30,
        type: 'likert',
        text: '[Response 3] You feel insulted—they must think you can’t handle things.',
      },
      {
        id: 'q31',
        number: 31,
        type: 'likert',
        text: '[Response 4] You tell them it’s none of their business and walk away.',
      },
    ],
  },
  {
    sectionNumber: 8,
    title: '[Situation 8]',
    description:
      'An old friend you haven’t heard from in years gets in touch seeking advice.',
    questions: [
      {
        id: 'q32',
        number: 32,
        type: 'likert',
        text: '[Response 1] You listen with care and do your best to be helpful.',
      },
      {
        id: 'q33',
        number: 33,
        type: 'likert',
        text: '[Response 2] You don’t really feel like talking and don’t reply.',
      },
      {
        id: 'q34',
        number: 34,
        type: 'likert',
        text: '[Response 3] You say something deep and unusual that makes sense to you, even if they might not fully get it.',
      },
      {
        id: 'q35',
        number: 35,
        type: 'likert',
        text: '[Response 4] You focus on the problem and give advice without getting emotional.',
      },
    ],
  },
  {
    sectionNumber: 9,
    title: '[Situation 9]',
    description:
      'After a long period of effort, you notice real progress on a goal.',
    questions: [
      {
        id: 'q36',
        number: 36,
        type: 'likert',
        text: '[Response 1] You beat yourself up for how long it’s taken.',
      },
      {
        id: 'q37',
        number: 37,
        type: 'likert',
        text: '[Response 2] You stay grounded and think about what still needs to happen.',
      },
      {
        id: 'q38',
        number: 38,
        type: 'likert',
        text: '[Response 3] You’re not sure you can really keep it going.',
      },
      {
        id: 'q39',
        number: 39,
        type: 'likert',
        text: '[Response 4] You feel focused and ready to push forward.',
      },
    ],
  },
  {
    sectionNumber: 10,
    title: '[Situation 10]',
    description:
      'You’re invited to help out on a project that aligns with your skills and interests.',
    questions: [
      {
        id: 'q40',
        number: 40,
        type: 'likert',
        text: '[Response 1] You agree, but only if you can lead it.',
      },
      {
        id: 'q41',
        number: 41,
        type: 'likert',
        text: '[Response 2] You say no—you’re too afraid to mess it up.',
      },
      {
        id: 'q42',
        number: 42,
        type: 'likert',
        text: '[Response 3] You say yes—it speaks to your values and feels meant to be.',
      },
      {
        id: 'q43',
        number: 43,
        type: 'likert',
        text: '[Response 4] You feel it’s exactly what you deserve.',
      },
    ],
  },
  {
    sectionNumber: 11,
    title: '[Situation 11]',
    description: 'You arrive at a very nice vacation spot.',
    questions: [
      {
        id: 'q44',
        number: 44,
        type: 'likert',
        text: '[Response 1] You start sketching or journaling to capture the vibe.',
      },
      {
        id: 'q45',
        number: 45,
        type: 'likert',
        text: '[Response 2] You settle in and let your companion take the lead.',
      },
      {
        id: 'q46',
        number: 46,
        type: 'likert',
        text: '[Response 3] You shout something like “This is paradise!” and pull your companion into a happy dance.',
      },
      {
        id: 'q47',
        number: 47,
        type: 'likert',
        text: '[Response 4] You’re there but feel like joy isn’t really meant for you.',
      },
    ],
  },
  {
    sectionNumber: 12,
    title: '[Situation 12]',
    description: 'Your friend shares exciting news.',
    questions: [
      {
        id: 'q48',
        number: 48,
        type: 'likert',
        text: '[Response 1] You feel inspired to push harder toward your own goals.',
      },
      {
        id: 'q49',
        number: 49,
        type: 'likert',
        text: '[Response 2] You stay quiet in the moment but later blow up about how unfair life feels to you.',
      },
      {
        id: 'q50',
        number: 50,
        type: 'likert',
        text: '[Response 3] You feels inadequate or ashamed for not having similar successes, and you feel guilty for your envy.',
      },
      {
        id: 'q51',
        number: 51,
        type: 'likert',
        text: '[Response 4] You congratulate them and listen with care.',
      },
    ],
  },
  {
    sectionNumber: 13,
    title: '[Situation 13]',
    description: 'A close friend grows distant.',
    questions: [
      {
        id: 'q52',
        number: 52,
        type: 'likert',
        text: '[Response 1] You give them space and figure they’ll come around.',
      },
      {
        id: 'q53',
        number: 53,
        type: 'likert',
        text: '[Response 2] You pretend not to care but start gossiping or twisting the story to make yourself look better.',
      },
      {
        id: 'q54',
        number: 54,
        type: 'likert',
        text: '[Response 3] You assume it’s your fault and wonder what you did wrong.',
      },
      {
        id: 'q55',
        number: 55,
        type: 'likert',
        text: '[Response 4] You feel anxious and physically tense—your body’s reacting.',
      },
    ],
  },
  {
    sectionNumber: 14,
    title: '[Situation 14]',
    description: 'Somebody publicly criticizes you in a harsh way.',
    questions: [
      {
        id: 'q56',
        number: 56,
        type: 'likert',
        text: '[Response 1] You explain your reasons calmly and clearly.',
      },
      {
        id: 'q57',
        number: 57,
        type: 'likert',
        text: '[Response 2] You lash out before you can think.',
      },
      {
        id: 'q58',
        number: 58,
        type: 'likert',
        text: '[Response 3] You nod and accept it, even if you disagree.',
      },
      {
        id: 'q59',
        number: 59,
        type: 'likert',
        text: '[Response 4] You shut down and say nothing ever pleases them anyway.',
      },
    ],
  },
  {
    sectionNumber: 15,
    title: '[Situation 15]',
    description:
      'A friend pressures you to do something shady or possibly illegal.',
    questions: [
      {
        id: 'q60',
        number: 60,
        type: 'likert',
        text: '[Response 1] You question their logic and point out the risks.',
      },
      {
        id: 'q61',
        number: 61,
        type: 'likert',
        text: '[Response 2] You give in—you don’t want to upset them.',
      },
      {
        id: 'q62',
        number: 62,
        type: 'likert',
        text: '[Response 3] You hesitate and feel conflicted, unsure of your judgment.',
      },
      {
        id: 'q63',
        number: 63,
        type: 'likert',
        text: '[Response 4] You go along with it, telling yourself it’s just this once.',
      },
    ],
  },
  {
    sectionNumber: 16,
    title: '[Situation 16]',
    description: 'Something you deeply value has been damaged or stolen.',
    questions: [
      {
        id: 'q64',
        number: 64,
        type: 'likert',
        text: '[Response 1] You take action immediately, assessing and solving the problem.',
      },
      {
        id: 'q65',
        number: 65,
        type: 'likert',
        text: '[Response 2] You think about how you could use this to your advantage, even if it means bending the truth.',
      },
      {
        id: 'q66',
        number: 66,
        type: 'likert',
        text: '[Response 3] You sigh and accept it quietly.',
      },
      {
        id: 'q67',
        number: 67,
        type: 'likert',
        text: '[Response 4] You suspect it wasn’t random—someone did it on purpose to get at you.',
      },
    ],
  },
  {
    sectionNumber: 17,
    title: '[Situation 17]',
    description: 'You’re asked to do something you’re unqualified for.',
    questions: [
      {
        id: 'q68',
        number: 68,
        type: 'likert',
        text: '[Response 1] You say yes immediately—you’re sure you’ll figure it out faster than anyone else.',
      },
      {
        id: 'q69',
        number: 69,
        type: 'likert',
        text: '[Response 2] You immediately ask someone else to guide you through it.',
      },
      {
        id: 'q70',
        number: 70,
        type: 'likert',
        text: '[Response 3] You explain it’s not your thing and suggest someone else.',
      },
      {
        id: 'q71',
        number: 71,
        type: 'likert',
        text: '[Response 4] You hesitate, wanting to know exactly why they chose you and what the risks are.',
      },
    ],
  },
  {
    sectionNumber: 18,
    title: '[Situation 18]',
    description: 'You find out that a group made plans without you.',
    questions: [
      {
        id: 'q72',
        number: 72,
        type: 'likert',
        text: '[Response 1] You fire back with a sharp comment.',
      },
      {
        id: 'q73',
        number: 73,
        type: 'likert',
        text: '[Response 2] You can’t stop thinking about it—it gets under your skin.',
      },
      {
        id: 'q74',
        number: 74,
        type: 'likert',
        text: '[Response 3] You say nothing and pull away.',
      },
      {
        id: 'q75',
        number: 75,
        type: 'likert',
        text: '[Response 4] You let it go and move on.',
      },
    ],
  },
  {
    sectionNumber: 19,
    title: '[Situation 19]',
    description: 'You have a heated argument with someone close.',
    questions: [
      {
        id: 'q76',
        number: 76,
        type: 'likert',
        text: '[Response 1] You double down and try to win the argument.',
      },
      {
        id: 'q77',
        number: 77,
        type: 'likert',
        text: '[Response 2] You assume you’re to blame and feel awful.',
      },
      {
        id: 'q78',
        number: 78,
        type: 'likert',
        text: '[Response 3] You express how you feel and stand your ground.',
      },
      {
        id: 'q79',
        number: 79,
        type: 'likert',
        text: '[Response 4] You accuse them of not respecting who you are.',
      },
    ],
  },
  {
    sectionNumber: 20,
    title: '[Situation 20]',
    description: 'Someone close breaks your trust.',
    questions: [
      {
        id: 'q80',
        number: 80,
        type: 'likert',
        text: '[Response 1] You say nothing and pretend it doesn’t matter.',
      },
      {
        id: 'q81',
        number: 81,
        type: 'likert',
        text: '[Response 2] You call them out calmly and make it clear that trust must be earned back.',
      },
      {
        id: 'q82',
        number: 82,
        type: 'likert',
        text: '[Response 3] You lash out with hurtful words.',
      },
      {
        id: 'q83',
        number: 83,
        type: 'likert',
        text: '[Response 4] You shut down and distance yourself from everyone.',
      },
    ],
  },
  {
    sectionNumber: 21,
    title: '[Situation 21]',
    description: 'You’re passed over for a promotion or opportunity.',
    questions: [
      {
        id: 'q84',
        number: 84,
        type: 'likert',
        text: '[Response 1] You feel like there’s no point in trying anymore.',
      },
      {
        id: 'q85',
        number: 85,
        type: 'likert',
        text: '[Response 2] You feel disappointed, but stay committed to what you believe in.',
      },
      {
        id: 'q86',
        number: 86,
        type: 'likert',
        text: '[Response 3] You feel panicked and start falling apart.',
      },
      {
        id: 'q87',
        number: 87,
        type: 'likert',
        text: '[Response 4] You feel wronged and tell yourself they’ll regret overlooking you.',
      },
    ],
  },
  {
    sectionNumber: 22,
    title: '[Situation 22]',
    description: 'You get a life-threatening medical result.',
    questions: [
      {
        id: 'q88',
        number: 88,
        type: 'likert',
        text: '[Response 1] You stay calm and begin sorting out your options.',
      },
      {
        id: 'q89',
        number: 89,
        type: 'likert',
        text: '[Response 2] You decide to face it with strength, no matter what.',
      },
      {
        id: 'q90',
        number: 90,
        type: 'likert',
        text: '[Response 3] You feel like it’s already over.',
      },
      {
        id: 'q91',
        number: 91,
        type: 'likert',
        text: '[Response 4] You break down and swing between fear and rage.',
      },
    ],
  },
  {
    sectionNumber: 23,
    title: '[Situation 23]',
    description:
      'You make a serious mistake that impacts someone close to you.',
    questions: [
      {
        id: 'q92',
        number: 92,
        type: 'likert',
        text: '[Response 1] You admit your mistake and own up to it.',
      },
      {
        id: 'q93',
        number: 93,
        type: 'likert',
        text: '[Response 2] You feel ashamed and try to avoid everyone involved.',
      },
      {
        id: 'q94',
        number: 94,
        type: 'likert',
        text: '[Response 3] You explain yourself in a way that’s hard for others to follow.',
      },
      {
        id: 'q95',
        number: 95,
        type: 'likert',
        text: '[Response 4] You promise to do whatever it takes to make it right next time.',
      },
    ],
  },
  {
    sectionNumber: 24,
    title: '[Situation 24]',
    description:
      'A long-time friend tells you something you said or did hurt them deeply.',
    questions: [
      {
        id: 'q96',
        number: 96,
        type: 'likert',
        text: '[Response 1] You gently acknowledge how much it must’ve hurt.',
      },
      {
        id: 'q97',
        number: 97,
        type: 'likert',
        text: '[Response 2] You feel ashamed and blame yourself entirely.',
      },
      {
        id: 'q98',
        number: 98,
        type: 'likert',
        text: '[Response 3] You suspect there’s more going on against you.',
      },
      {
        id: 'q99',
        number: 99,
        type: 'likert',
        text: '[Response 4] You shut down and decide to keep people at a distance from now on.',
      },
    ],
  },
  {
    sectionNumber: 25,
    title: '[Situation 25]',
    description: 'You’re going through a breakup or divorce.',
    questions: [
      {
        id: 'q100',
        number: 100,
        type: 'likert',
        text: '[Response 1] You’re heartbroken, but still believe in love and what it can be.',
      },
      {
        id: 'q101',
        number: 101,
        type: 'likert',
        text: '[Response 2] You lash out one moment and beg for another chance the next.',
      },
      {
        id: 'q102',
        number: 102,
        type: 'likert',
        text: '[Response 3] You start thinking of ways to get back at them.',
      },
      {
        id: 'q103',
        number: 103,
        type: 'likert',
        text: '[Response 4] You broadcast your pain publicly or tell everyone the story.',
      },
    ],
  },
  {
    sectionNumber: 26,
    title: '[Situation 26]',
    description: 'You’re hit with a major unexpected expense.',
    questions: [
      {
        id: 'q104',
        number: 104,
        type: 'likert',
        text: '[Response 1] You feel defeated and think things never go your way.',
      },
      {
        id: 'q105',
        number: 105,
        type: 'likert',
        text: '[Response 2] You come up with an unconventional way to handle it.',
      },
      {
        id: 'q106',
        number: 106,
        type: 'likert',
        text: '[Response 3] You start telling every family member what they need to cut back on.',
      },
      {
        id: 'q107',
        number: 107,
        type: 'likert',
        text: "[Response 4] You stay calm and reassure those around you that you'll get through it together.",
      },
    ],
  },
  {
    sectionNumber: 27,
    title: '[Situation 27]',
    description:
      'In pursuing an important goal, you experienced a series of setbacks.',
    questions: [
      {
        id: 'q108',
        number: 108,
        type: 'likert',
        text: '[Response 1] You keep going—you haven’t lost sight of the goal.',
      },
      {
        id: 'q109',
        number: 109,
        type: 'likert',
        text: '[Response 2] You feel irritated and can’t settle down.',
      },
      {
        id: 'q110',
        number: 110,
        type: 'likert',
        text: '[Response 3] You double down, tighten your routine, and try to control every detail.',
      },
      {
        id: 'q111',
        number: 111,
        type: 'likert',
        text: '[Response 4] You hope someone will step in and fix it for you.',
      },
    ],
  },
  {
    sectionNumber: 28,
    title: '[Situation 28]',
    description:
      'Someone cuts in front of you at a coffee shop and dismisses you.',
    questions: [
      {
        id: 'q112',
        number: 112,
        type: 'likert',
        text: '[Response 1] You demand an apology and refuse to let it go until order is restored.',
      },
      {
        id: 'q113',
        number: 113,
        type: 'likert',
        text: '[Response 2] You say nothing and wonder if you were wrong to speak up.',
      },
      {
        id: 'q114',
        number: 114,
        type: 'likert',
        text: '[Response 3] You snap back loudly, insulting them.',
      },
      {
        id: 'q115',
        number: 115,
        type: 'likert',
        text: '[Response 4] You can’t stop replaying the moment in your head for the rest of the day.',
      },
    ],
  },
  {
    sectionNumber: 29,
    title: '[Situation 29]',
    description:
      'Your trip isn’t going as planned—bad weather forces cancellations.',
    questions: [
      {
        id: 'q116',
        number: 116,
        type: 'likert',
        text: '[Response 1] You make a backup plan and try to keep things on track.',
      },
      {
        id: 'q117',
        number: 117,
        type: 'likert',
        text: '[Response 2] You give up—nothing ever goes right anyway.',
      },
      {
        id: 'q118',
        number: 118,
        type: 'likert',
        text: '[Response 3] You feel drained and tense—your body’s reacting to the stress.',
      },
      {
        id: 'q119',
        number: 119,
        type: 'likert',
        text: '[Response 4] You come up with a quirky new idea to turn the day around.',
      },
    ],
  },
  {
    sectionNumber: 30,
    title: '[Situation 30]',
    description:
      'Your partner or roommate does housework in a way you don’t like.',
    questions: [
      {
        id: 'q120',
        number: 120,
        type: 'likert',
        text: '[Response 1] You take over and insist on doing it your way.',
      },
      {
        id: 'q121',
        number: 121,
        type: 'likert',
        text: '[Response 2] You let it go—everyone has their own style.',
      },
      {
        id: 'q122',
        number: 122,
        type: 'likert',
        text: '[Response 3] You feel they don’t understand how different and complex you are.',
      },
      {
        id: 'q123',
        number: 123,
        type: 'likert',
        text: '[Response 4] You think they’re doing it on purpose to bother you.',
      },
    ],
  },
  {
    sectionNumber: 31,
    title: '[Situation 31]',
    description:
      'You and your family or friends are vacationing in a new and unfamiliar place.',
    questions: [
      {
        id: 'q124',
        number: 124,
        type: 'likert',
        text: '[Response 1] You prepare a detailed plan to make sure everything runs smoothly.',
      },
      {
        id: 'q125',
        number: 125,
        type: 'likert',
        text: '[Response 2] You can’t stop talking about how exciting everything is.',
      },
      {
        id: 'q126',
        number: 126,
        type: 'likert',
        text: '[Response 3] You focus on avoiding anything risky.',
      },
      {
        id: 'q127',
        number: 127,
        type: 'likert',
        text: '[Response 4] You dive right in, chatting with locals and leading the group with playful energy.',
      },
    ],
  },
  {
    sectionNumber: 32,
    title: '[Situation 32]',
    description: 'A close friend or family member has passed away.',
    questions: [
      {
        id: 'q128',
        number: 128,
        type: 'likert',
        text: '[Response 1] You cry openly—it’s how you deal with strong emotion.',
      },
      {
        id: 'q129',
        number: 129,
        type: 'likert',
        text: '[Response 2] You focus on comforting their loved ones.',
      },
      {
        id: 'q130',
        number: 130,
        type: 'likert',
        text: '[Response 3] You avoid talking about it—it’s too much.',
      },
      {
        id: 'q131',
        number: 131,
        type: 'likert',
        text: '[Response 4] You can’t shake the feeling that their death seems suspicious.',
      },
    ],
  },
  {
    sectionNumber: 33,
    title: '[Situation 33]',
    description:
      'You attend a social event hoping to connect, but no one engages with you.',
    questions: [
      {
        id: 'q132',
        number: 132,
        type: 'likert',
        text: '[Response 1] You try something big or funny to get people’s attention.',
      },
      {
        id: 'q133',
        number: 133,
        type: 'likert',
        text: '[Response 2] You feel like no one understands your inner world anyway.',
      },
      {
        id: 'q134',
        number: 134,
        type: 'likert',
        text: '[Response 3] You quietly avoid people—you’re afraid to mess up.',
      },
      {
        id: 'q135',
        number: 135,
        type: 'likert',
        text: '[Response 4] You walk over and start a conversation with someone new.',
      },
    ],
  },
  {
    sectionNumber: 34,
    title: '[Situation 34]',
    description:
      'A server brings you a meal with an ingredient you asked to leave out.',
    questions: [
      {
        id: 'q136',
        number: 136,
        type: 'likert',
        text: '[Response 1] You say something sharp, demeaning to the server.',
      },
      {
        id: 'q137',
        number: 137,
        type: 'likert',
        text: '[Response 2] You politely explain the issue and ask them to correct it.',
      },
      {
        id: 'q138',
        number: 138,
        type: 'likert',
        text: '[Response 3] You quietly eat around it.',
      },
      {
        id: 'q139',
        number: 139,
        type: 'likert',
        text: '[Response 4] You insist they redo the order exactly as requested and double-check every step.',
      },
    ],
  },
  {
    sectionNumber: 35,
    title: '[Situation 35]',
    description:
      'Someone close tells you they don’t like how you handle something important.',
    questions: [
      {
        id: 'q140',
        number: 140,
        type: 'likert',
        text: '[Response 1] You wonder if anyone will ever truly like or accept you.',
      },
      {
        id: 'q141',
        number: 141,
        type: 'likert',
        text: '[Response 2] You believe your way is just too different for others to understand.',
      },
      {
        id: 'q142',
        number: 142,
        type: 'likert',
        text: '[Response 3] You think it’s their problem—your way is fine.',
      },
      {
        id: 'q143',
        number: 143,
        type: 'likert',
        text: '[Response 4] You feel awful and think you’ve let them down completely.',
      },
    ],
  },
  {
    sectionNumber: 36,
    title: '[Situation 36]',
    description:
      'A friend or family member occasionally vents to you about feeling burned out.',
    questions: [
      {
        id: 'q144',
        number: 144,
        type: 'likert',
        text: '[Response 1] You listen with concern and try to support them.',
      },
      {
        id: 'q145',
        number: 145,
        type: 'likert',
        text: '[Response 2] You feel uncomfortable and keep your distance.',
      },
      {
        id: 'q146',
        number: 146,
        type: 'likert',
        text: '[Response 3] You get annoyed and feel like they’re dragging you down.',
      },
      {
        id: 'q147',
        number: 147,
        type: 'likert',
        text: '[Response 4] You tell them their problems are probably their own fault.',
      },
    ],
  },
  // Personal particulars moved to end
  {
    sectionNumber: 37,
    title: 'Your personal particulars',
    description:
      'One more step: enter your name please ',
    questions: [
      { id: 'q1', number: 1, type: 'text', text: 'Name' },
      { id: 'q2', number: 2, type: 'text', text: 'Age' },
      { id: 'q3', number: 3, type: 'text', text: 'Email address' },
    ],
  },
];
